/**
 * The stored answer key of a hidden article: the hidden words in numbering order and where
 * they come from. The import writes it; the author never types it. Kept apart from the
 * component so the eagerly loaded module file never pulls the readback into the bundle.
 */
import type { HiddenArticleDefinition } from "./types";

export interface HiddenArticleSolution {
  words: string[];
  source?: { url?: string; title?: string };
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function emptySolution(_definition: HiddenArticleDefinition): HiddenArticleSolution {
  return { words: [] };
}

/** Reads whatever is stored, however wrong, and keeps what it can use. */
export function solutionOf(value: unknown): HiddenArticleSolution {
  if (!isRecord(value)) return { words: [] };
  const words = Array.isArray(value.words)
    ? value.words.filter((w): w is string => typeof w === "string")
    : [];
  const solution: HiddenArticleSolution = { words };
  if (isRecord(value.source)) {
    const source: { url?: string; title?: string } = {};
    if (typeof value.source.url === "string") source.url = value.source.url;
    if (typeof value.source.title === "string") source.title = value.source.title;
    solution.source = source;
  }
  return solution;
}
